// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c8b3bbe1","119":"30df2e47","321":"3bdb30f0","332":"eb0e94bb","335":"a5a85de6","349":"f608bfae","498":"53d5a325","500":"40605810","573":"3bc87957","643":"be59b8bf","817":"e9c1c66b","858":"23bfdf31"}[chunkId] + ".chunk.js";
};